import { Record } from "immutable";
import moment from "moment";

const defaults = {
    collectionId: undefined,
    granted_to: {},
    granted_by: {},
    users: [],
};

interface IGrant {
    display_name: string;
    kind: string;
    member_id: string;
    merchant_id: string;
    team_id: string;
    user_id: string;
}

interface IUserPermission {
    id: string;
    collection_id: string;
    item_id: string;
    create_time: moment.Moment;
    update_time: moment.Moment;
    role: string;
    email?: string;
    name?: string;
    granted_to: IGrant;
    granted_by: IGrant;
}

export class CollectionPermission extends Record(defaults) {
    declare collectionId: string;
    declare users: [IUserPermission];

    constructor(args) {
        super({
            ...args,
            users: (args.users || []).map((user) => ({
                ...user,
                create_time: moment.utc(parseInt(user.create_time, 10)),
            })),
        });
    }
}
